export default __webpack_public_path__ + "static/media/FAQ_10_1.cd6856ce.png";